<div class="container border rounded pt-4 pb-2">
	<div class="row text-center mb-4">
		<span class="theme-main-color fw-bold fs-4"> Temps de travail </span>
	</div>
	<div class="row my-2">
		<div class="col">
			<div class="row">
				<span class="theme-main-color fw-bold fs-4 text-center">
					Temps total par semaine</span
				>
			</div>
			<div class="row my-2">
				<table class="table mt-3 theme-main-color">
					<caption>
						Temps total par semaine
					</caption>
					<thead>
						<tr>
							<th scope="col">Competences</th>
							<th scope="col">Moyenne</th>
							<th scope="col">Min.</th>
							<th scope="col">Max.</th>
						</tr>
					</thead>
					<tbody *ngIf="isSESSAD">
						<tr *ngIf="lpcStats?.nombrePlanning > 0">
							<th scope="row">LPC</th>
							<td>
								{{ lpcStats?.beanParametreStatistiqueTempsTotal.tempsMoyenne }}
							</td>
							<td>
								{{ lpcStats?.beanParametreStatistiqueTempsTotal.tempsMin }}
							</td>
							<td>
								{{ lpcStats?.beanParametreStatistiqueTempsTotal.tempsMax }}
							</td>
						</tr>
						<tr *ngIf="lsfStats?.nombrePlanning > 0">
							<th scope="row">LSF</th>
							<td>
								{{ lsfStats?.beanParametreStatistiqueTempsTotal.tempsMoyenne }}
							</td>
							<td>
								{{ lsfStats?.beanParametreStatistiqueTempsTotal.tempsMin }}
							</td>
							<td>
								{{ lsfStats?.beanParametreStatistiqueTempsTotal.tempsMax }}
							</td>
						</tr>
						<tr *ngIf="pdnStats?.nombrePlanning > 0">
							<th scope="row">PDN</th>
							<td>
								{{ pdnStats?.beanParametreStatistiqueTempsTotal.tempsMoyenne }}
							</td>
							<td>
								{{ pdnStats?.beanParametreStatistiqueTempsTotal.tempsMin }}
							</td>
							<td>
								{{ pdnStats?.beanParametreStatistiqueTempsTotal.tempsMax }}
							</td>
						</tr>
						<tr *ngIf="oralStats?.nombrePlanning > 0">
							<th scope="row">Oral</th>
							<td>
								{{ oralStats?.beanParametreStatistiqueTempsTotal.tempsMoyenne }}
							</td>
							<td>
								{{ oralStats?.beanParametreStatistiqueTempsTotal.tempsMin }}
							</td>
							<td>
								{{ oralStats?.beanParametreStatistiqueTempsTotal.tempsMax }}
							</td>
						</tr>
					</tbody>
					<tbody *ngIf="isSAAD">
						<tr *ngIf="globalStats?.nombrePlanning > 0">
							<th scope="row">Aide à domicile</th>
							<td>
								{{
									globalStats?.beanParametreStatistiqueTempsTotal.tempsMoyenne
								}}
							</td>
							<td>
								{{ globalStats?.beanParametreStatistiqueTempsTotal.tempsMin }}
							</td>
							<td>
								{{ globalStats?.beanParametreStatistiqueTempsTotal.tempsMax }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="col">
			<div echarts [options]="option"></div>
		</div>
	</div>

	<div class="row">
		<div class="col">
			<div class="row">
				<span class="theme-main-color fw-bold fs-4 text-center">
					Temps de prestation</span
				>
			</div>
			<div class="row my-2">
				<div class="container">
					<table class="table mt-3 theme-main-color">
						<caption>
							Temps de prestation
						</caption>
						<thead>
							<tr>
								<th scope="col">Categorie</th>
								<th scope="col">Moyenne</th>
								<th scope="col">Min.</th>
								<th scope="col">Max.</th>
							</tr>
						</thead>
						<tbody *ngIf="isSESSAD">
							<tr *ngIf="lpcStats?.nombrePlanning > 0">
								<th scope="row">LPC</th>
								<td>
									{{
										lpcStats?.beanParametreStatistiqueTempsTravail.tempsMoyenne
									}}
								</td>
								<td>
									{{ lpcStats?.beanParametreStatistiqueTempsTravail.tempsMin }}
								</td>
								<td>
									{{ lpcStats?.beanParametreStatistiqueTempsTravail.tempsMax }}
								</td>
							</tr>
							<tr *ngIf="lsfStats?.nombrePlanning > 0">
								<th scope="row">LSF</th>
								<td>
									{{
										lsfStats?.beanParametreStatistiqueTempsTravail.tempsMoyenne
									}}
								</td>
								<td>
									{{ lsfStats?.beanParametreStatistiqueTempsTravail.tempsMin }}
								</td>
								<td>
									{{ lsfStats?.beanParametreStatistiqueTempsTravail.tempsMax }}
								</td>
							</tr>
							<tr *ngIf="pdnStats?.nombrePlanning > 0">
								<th scope="row">PDN</th>
								<td>
									{{
										pdnStats?.beanParametreStatistiqueTempsTravail.tempsMoyenne
									}}
								</td>
								<td>
									{{ pdnStats?.beanParametreStatistiqueTempsTravail.tempsMin }}
								</td>
								<td>
									{{ pdnStats?.beanParametreStatistiqueTempsTravail.tempsMax }}
								</td>
							</tr>
							<tr *ngIf="oralStats?.nombrePlanning > 0">
								<th scope="row">Oral</th>
								<td>
									{{
										oralStats?.beanParametreStatistiqueTempsTravail.tempsMoyenne
									}}
								</td>
								<td>
									{{ oralStats?.beanParametreStatistiqueTempsTravail.tempsMin }}
								</td>
								<td>
									{{ oralStats?.beanParametreStatistiqueTempsTravail.tempsMax }}
								</td>
							</tr>
						</tbody>
						<tbody *ngIf="isSAAD">
							<tr *ngIf="globalStats?.nombrePlanning > 0">
								<th scope="row">Aide à domicile</th>
								<td>
									{{
										globalStats?.beanParametreStatistiqueTempsTravail
											.tempsMoyenne
									}}
								</td>
								<td>
									{{
										globalStats?.beanParametreStatistiqueTempsTravail.tempsMin
									}}
								</td>
								<td>
									{{
										globalStats?.beanParametreStatistiqueTempsTravail.tempsMax
									}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>

		<div class="col">
			<div class="row">
				<span class="theme-main-color fw-bold fs-4 text-center">
					Temps de trajet</span
				>
			</div>
			<div class="row my-2">
				<div class="container">
					<table class="table mt-3 theme-main-color">
						<caption>
							Temps de trajet
						</caption>
						<thead>
							<tr>
								<th scope="col">#</th>
								<th scope="col">Moyenne</th>
								<th scope="col">Min.</th>
								<th scope="col">Max.</th>
							</tr>
						</thead>
						<tbody *ngIf="isSESSAD">
							<tr *ngIf="lpcStats?.nombrePlanning > 0">
								<th scope="row">LPC</th>
								<td>
									{{
										lpcStats?.beanParametreStatistiqueTempsTrajet.tempsMoyenne
									}}
								</td>
								<td>
									{{ lpcStats?.beanParametreStatistiqueTempsTrajet.tempsMin }}
								</td>
								<td>
									{{ lpcStats?.beanParametreStatistiqueTempsTrajet.tempsMax }}
								</td>
							</tr>
							<tr *ngIf="lsfStats?.nombrePlanning > 0">
								<th scope="row">LSF</th>
								<td>
									{{
										lsfStats?.beanParametreStatistiqueTempsTrajet.tempsMoyenne
									}}
								</td>
								<td>
									{{ lsfStats?.beanParametreStatistiqueTempsTrajet.tempsMin }}
								</td>
								<td>
									{{ lsfStats?.beanParametreStatistiqueTempsTrajet.tempsMax }}
								</td>
							</tr>
							<tr *ngIf="pdnStats?.nombrePlanning > 0">
								<th scope="row">PDN</th>
								<td>
									{{
										pdnStats?.beanParametreStatistiqueTempsTrajet.tempsMoyenne
									}}
								</td>
								<td>
									{{ pdnStats?.beanParametreStatistiqueTempsTrajet.tempsMin }}
								</td>
								<td>
									{{ pdnStats?.beanParametreStatistiqueTempsTrajet.tempsMax }}
								</td>
							</tr>
							<tr *ngIf="oralStats?.nombrePlanning > 0">
								<th scope="row">Oral</th>
								<td>
									{{
										oralStats?.beanParametreStatistiqueTempsTrajet.tempsMoyenne
									}}
								</td>
								<td>
									{{ oralStats?.beanParametreStatistiqueTempsTrajet.tempsMin }}
								</td>
								<td>
									{{ oralStats?.beanParametreStatistiqueTempsTrajet.tempsMax }}
								</td>
							</tr>
						</tbody>
						<tbody *ngIf="isSAAD">
							<tr *ngIf="globalStats?.nombrePlanning > 0">
								<th scope="row">Aide à domicile</th>
								<td>
									{{
										globalStats?.beanParametreStatistiqueTempsTrajet
											.tempsMoyenne
									}}
								</td>
								<td>
									{{
										globalStats?.beanParametreStatistiqueTempsTrajet.tempsMin
									}}
								</td>
								<td>
									{{
										globalStats?.beanParametreStatistiqueTempsTrajet.tempsMax
									}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row my-4">
		<div class="col" *ngIf="isSESSAD">
			<div class="">
				<div class="row">
					<div class="col text-center fw-bold fs-4">
						{{ boxPlotTitle }}
					</div>
					<div class="col">
						<div class="input-group">
							<select
								[(ngModel)]="categorie"
								class="form-select"
								id="inputGroupSelect02"
							>
								<option selected value="1">LPC</option>
								<option value="2">LSF</option>
								<option value="3">Prise de note</option>
								<option value="4">Oral</option>
							</select>
							<label class="input-group-text" for="inputGroupSelect02"
								>Cat.</label
							>
						</div>
					</div>
				</div>
			</div>
			<app-working-time-dispersion
				[statistiquesTotal]="[
					stats && stats[categorie].beanParametreStatistiqueTempsTotal.tempsQ1,
					stats && stats[categorie].beanParametreStatistiqueTempsTotal.tempsQ3,
					stats && stats[categorie].beanParametreStatistiqueTempsTotal.tempsMin,
					stats && stats[categorie].beanParametreStatistiqueTempsTotal.tempsMax,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTotal.tempsMediane,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTotal.tempsMoyenne,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTotal.tempsEcartType
				]"
				[statistiquesTrajet]="[
					stats && stats[categorie].beanParametreStatistiqueTempsTrajet.tempsQ1,
					stats && stats[categorie].beanParametreStatistiqueTempsTrajet.tempsQ3,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTrajet.tempsMin,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTrajet.tempsMax,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTrajet.tempsMediane,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTrajet.tempsMoyenne,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTrajet.tempsEcartType
				]"
				[statistiquesTravail]="[
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTravail.tempsQ1,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTravail.tempsQ3,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTravail.tempsMin,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTravail.tempsMax,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTravail.tempsMediane,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTravail.tempsMoyenne,
					stats &&
						stats[categorie].beanParametreStatistiqueTempsTravail.tempsEcartType
				]"
				[categorie]="categorie"
			></app-working-time-dispersion>
		</div>
		<div class="col" *ngIf="isSAAD">
			<div class="">
				<div class="row">
					<div class="col text-center fw-bold fs-4">
						{{ boxPlotTitle }}
					</div>
				</div>
			</div>
			<app-working-time-dispersion
				[statistiquesTotal]="[
					globalStats && globalStats.beanParametreStatistiqueTempsTotal.tempsQ1,
					globalStats && globalStats.beanParametreStatistiqueTempsTotal.tempsQ3,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTotal.tempsMin,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTotal.tempsMax,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTotal.tempsMediane,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTotal.tempsMoyenne,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTotal.tempsEcartType
				]"
				[statistiquesTrajet]="[
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTrajet.tempsQ1,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTrajet.tempsQ3,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTrajet.tempsMin,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTrajet.tempsMax,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTrajet.tempsMediane,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTrajet.tempsMoyenne,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTrajet.tempsEcartType
				]"
				[statistiquesTravail]="[
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTravail.tempsQ1,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTravail.tempsQ3,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTravail.tempsMin,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTravail.tempsMax,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTravail.tempsMediane,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTravail.tempsMoyenne,
					globalStats &&
						globalStats.beanParametreStatistiqueTempsTravail.tempsEcartType
				]"
				[categorie]="categorie"
			></app-working-time-dispersion>
		</div>
	</div>
</div>
